import prodAnalyticsSaga from './prod-analytics.saga';

export default prodAnalyticsSaga;
